// extracted by mini-css-extract-plugin
module.exports = {"jsonContent":"JsonModal_jsonContent___duj3","json":"JsonModal_json__KakH7"};